import { AccountTypeEnum as AccountType } from "../../graphql/supergraphTypes";

/**
 * Possible initial pages that can be shown in the subscription compliance flow
 */
export enum InitialPage {
  NoRootProfile = "no_root_profile",
  Individual = "individual",
  Joint = "joint",
  IraCategorization = "ira_categorization",
  Overview = "overview",
  Tree = "tree",
}

export type InitialPageArgs = {
  accountType?: AccountType | null;
  iraConsentStatus: boolean | null;
  detailsCompleted: boolean | null;
  documentsCompleted: boolean;
  areOwnersCompleted: boolean;
  areControllersCompleted: boolean;
};
